export default __webpack_public_path__ + "static/media/fifthIconRight.c0cf155b.svg";